<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

export default {
  name: 'App',
  //  data() {

  //  }
}
</script>
 
<style lang="less">
@import "./common.less";

</style>



// WEBPACK FOOTER //
// src/App.vue